export default function ({ $auth, redirect }) {
  const user = $auth.user
  if (user.role !== 'super_admin') {
    // return redirect('/whatsapp/contacts')
  }
}
